var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApprovedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 38,
    height: 38,
    rx: 3,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9543 18.4911L21.3287 27.55L17.105 23.2137C16.9362 23.0403 16.7357 22.9027 16.5151 22.8088C16.2945 22.7149 16.0581 22.6665 15.8192 22.6664C15.3369 22.6662 14.8743 22.8628 14.5331 23.2128C14.1919 23.5628 14.0002 24.0376 14 24.5328C13.9998 25.028 14.1913 25.5029 14.5322 25.8532L19.9869 31.4532C20.3182 31.7934 20.7647 31.9891 21.2332 31.9996C21.7017 32.01 22.1561 31.8343 22.5015 31.5092L33.4108 21.2425C33.7662 20.9079 33.9775 20.442 33.9983 19.9473C34.0191 19.4527 33.8477 18.9698 33.5217 18.6049C33.1957 18.2401 32.7419 18.0231 32.2601 18.0017C31.7783 17.9804 31.3079 18.1564 30.9525 18.4911H30.9543Z",
    fill: "#717070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedIcon);
export default __webpack_public_path__ + "static/media/approved-icon.efb74da87760f90d289695bc597028bc.svg";
export { ForwardRef as ReactComponent };